import { useRouter } from "next/router"
import dynamic from "next/dynamic"

const AddAppollowToYourHomeScreenAR = dynamic(
  () => import("views/articles/AddToHomeScreen/ar"),
)
const AddAppollowToYourHomeScreenTR = dynamic(
  () => import("views/articles/AddToHomeScreen/tr"),
)
const AddAppollowToYourHomeScreenEN = dynamic(
  () => import("views/articles/AddToHomeScreen/en"),
)

const AddAppollowToYourHomeScreen = () => {
  const router = useRouter()

  if (router.locale === "ar") return <AddAppollowToYourHomeScreenAR />
  if (router.locale === "tr-TR") return <AddAppollowToYourHomeScreenTR />
  return <AddAppollowToYourHomeScreenEN />
}

export default AddAppollowToYourHomeScreen
